<template>
	<div class="certi-phone-wrap" @click="hideCerti">
		<div class="certi-phone-inner">
			<p class="title">手机号认证</p>
			<div class="edit-list">
				<p class="tips">认证手机号后，下次登录可使用手机号登录。</p>
				<ul>
					<li>
						<span class="name">手机号</span>
						<span class="value"><input type="tel" placeholder="请填写您的手机号"/></span>
					</li>
					<li>
						<span class="name">验证码</span>
						<span class="value"><input type="text" placeholder="请输入短信验证码"/><span>获取验证码</span></span>
					</li>
				</ul>
				<p class="certi-btn"><button>提交认证</button></p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"certi-phone",
		props:["uid"],
		data(){
			return{
				
			}
		},
		methods:{
			hideCerti(){
				this.$emit("hide")
			}
		}
	}
</script>

<style scoped>
	.certi-phone-wrap{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.3);
		z-index: 10;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1rem;
	}
	.certi-phone-inner{
		background: #fff;
		width: 100%;
		border-radius: 6px;
		padding: 1rem 0;
	}
	.certi-phone-inner .title{
		font-size: 1rem;
		color: #282828;
		text-align: center;
		line-height: 2rem;
		font-weight: bold;
		margin-bottom: 1rem;
	}
	.certi-phone-inner li{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-bottom: 1px solid #f3f3f3;
		padding: 0 1rem;
	}
	.certi-phone-inner li .name{
		width: 4rem;
	}
	.certi-phone-inner li .value{
		flex: 1;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		position: relative;
	}
	.certi-phone-inner li .value input{
		flex: 1;
		height: 2.5rem;
		padding: 0 0.5rem;
		border: 0;
		outline: 0;
		background: none;
	}
	.certi-phone-inner li .value span{
		font-size: 0.8rem;
		color: rgba(84,21,249,.6);
		width: 5rem;
		text-align: center;
		border: 1px solid rgba(84,21,249,.6);
		padding: 0.3rem 0;
		border-radius: 4px;
		position: absolute;
		right: 0;
	}
	.certi-phone-inner li .value span:active{
		background: rgba(84,21,249,.6);
		color: #fff;
	}
	.certi-phone-inner .tips{
		background: rgba(84,21,249,.2);
		font-size: 0.8rem;
		line-height: 1.5rem;
		color: rgba(84,21,249,.8);
		padding: 0.4rem 1rem;
	}
	.certi-phone-inner .certi-btn{
		text-align: center;
		padding: 1.8rem 0 0;
	}
	.certi-phone-inner .certi-btn button{
	    width: 60%;
	    height: 2.5rem;
	    background: linear-gradient(45deg, rgba(118, 68, 250, 1) 0%, rgba(156, 124, 255, 1) 100%);
	    border-radius: 4px;
	    border: 0;
	    outline: 0;
	    color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/CertiPhone.vue